import React from "react"
import { Box, Tab, Tabs } from "@mui/material"
import { useDispatch } from "react-redux"
import { COLORS, formatDateUrl } from "../../utils"
import { ALERTS_PATHS } from "../../utils/alertsUtils"
import { showAlerts } from "../../actions/ProductionSteps/alerts"
import QHSEConformity from "./QHSEConformity/QHSEConformity"
import CookingDelays from "./cookingDelays/CookingDelays"
import ReproductionNeeds from "./reproductionNeeds/ReproductionNeeds"
import AlertsLayout from "./AlertsLayout"

const sx = {
    tabsBar: {
        position: "sticky",
        top: 64,
        zIndex: 10,
        backgroundColor: COLORS.WHITE,
        borderBottom: "1px solid #E6E6E6",
        paddingTop: "8px",
        width: "100%",
    },
    tabs: {
        m: 0,
        display: "flex",
        "& .MuiTabs-flexContainer": { justifyContent: "center" },
        "& .MuiTab-root": { padding: "16px 24px" },
    },
}

const tabsOptions = [
    { value: ALERTS_PATHS.cookingDelays, label: "Retards cuisine" },
    { value: ALERTS_PATHS.conditioningDelays, label: "Retards condis" },
    { value: ALERTS_PATHS.reproductionNeeds, label: "Reprods" },
    { value: ALERTS_PATHS.qhseConformity, label: "Conformité QHSE" },
]

const getDateStr = (date, isIntelStrFormat = true) => {
    return date ? formatDateUrl(date, isIntelStrFormat) : undefined
}

const Alerts = ({ params: { tab = false }, routeParams = {} }) => {
    const dispatch = useDispatch()

    const handleTabChange = (_, value) => {
        dispatch(showAlerts(routeParams.date, value))
    }

    return (
        <AlertsLayout date={getDateStr(routeParams.date, false)}>
           {/* ----------- tabs ----------- */}
            <Box sx={sx.tabsBar}>
                <Tabs
                    value={tab}
                    textColor="primary"
                    indicatorColor="primary"
                    sx={sx.tabs}
                    onChange={handleTabChange}
                >
                    {tabsOptions.map((tab) => (
                        <Tab
                            key={tab.value}
                            value={tab.value}
                            label={tab.label}
                        />
                    ))}
                </Tabs>
            </Box>
            {/* ------- tab content -------- */}
            {tab === ALERTS_PATHS.qhseConformity && <QHSEConformity dateStr={getDateStr(routeParams.date)} />}
            {tab === ALERTS_PATHS.cookingDelays && <CookingDelays dateStr={getDateStr(routeParams.date)} />}
            {tab === ALERTS_PATHS.reproductionNeeds && <ReproductionNeeds />}
        </AlertsLayout>
    )
}

export default Alerts
